import Button from '@mui/material/Button';
import { useState } from 'react';
import { useNotify, useRecordContext } from 'react-admin';

import RecordOutreachDialog from './RecordOutreachDialog';
import type { IndustryContributor } from '@/Api/studioServerTypes';

export default function RecordOutreachButton({
  stopPropagation = false,
}: {
  stopPropagation?: boolean;
}): JSX.Element | null {
  const notify = useNotify();
  const record = useRecordContext<IndustryContributor>();
  const [open, setOpen] = useState(false);
  const targetContributorId = (record?.IndustryContributorIdentifier ?? '').trim();
  const hasContact = Boolean((record?.ContactIdentifier ?? record?.ContactIdentifierNavigation?.ContactIdentifier ?? '').trim());

  if (!targetContributorId) {
    return null;
  }

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        size='small'
        onClick={(event) => {
          if (stopPropagation) {
            event.preventDefault();
            event.stopPropagation();
          }

          if (!hasContact) {
            notify('Please add a contact before recording outreach', { type: 'warning', autoHideDuration: 3000 });
            return;
          }

          setOpen(true);
        }}
        sx={{
          borderRadius: 6,
          textTransform: 'none',
        }}
      >
        Record outreach
      </Button>

      <RecordOutreachDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
